module.exports = __webpack_public_path__ + "static/media/modem.c38c78f9.png";